import { SETPOSITION } from './types/field.index.types'
import { GAMESTATUSTYPES } from './types/gameStatus.index.types'

export const GameStatus: GAMESTATUSTYPES = {
  init: 'init',
  playing: 'playing',
  suspended: 'suspended',
  gameover: 'gameover',
};

export const isGameOver = (fieldSize: number, position: SETPOSITION) => {
  if (position.y < 0 || position.x < 0) {
    return true;
  }

  if (position.y > fieldSize - 1 || position.x > fieldSize - 1) {
    return true;
  }

  return false;
};